import React from 'react';
import Reveal from '../ui/Reveal';

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 bg-brand-deep text-brand-cream overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          
          <Reveal>
            <div className="relative aspect-[3/4] max-w-md mx-auto md:mx-0 bg-brand-olive overflow-hidden border border-brand-cream/10">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/950656ff8acc2b4c64dfb2a5e756971f95d9a65d0f8c5ef3b6e107600fb8dee58cb5b46485e4f90e0b9e2ba9c3364607/images/aW1hZ2UvcG5n/f08d98afd358b0b46bf34f037aeb2744.png" 
                alt="Mugdha Yelkar - Fractional COO and creator of Clarity90, working with founder-led businesses across India" 
                className="w-full h-full object-cover object-top transition-all duration-700"
              />
              <div className="absolute inset-0 border border-brand-cream/20 m-4 pointer-events-none" />
            </div>
          </Reveal>

          <div>
            <Reveal>
              <h2 className="font-serif text-4xl md:text-5xl mb-8">The human architecture beneath the org chart.</h2>
            </Reveal>
            
            <Reveal delay={0.2}>
              <div className="space-y-6 text-lg font-light text-brand-cream/80 leading-relaxed">
                <p>
                  I am Mugdha Yelkar. Over the last 16 years, I have worked across architecture, UNESCO heritage management, rural development, EdTech, and operational transformation.
                </p>
                <p>
                  This unusual background taught me one critical truth. Systems fail when they ignore how human beings actually behave.
                </p>
                <p>
                  I specialize in working across ambiguity, complexity, under-resourced environments, and multi-stakeholder systems. I do not build theoretical frameworks. I build operating systems that teams actually use, allowing purpose-driven founders to step out of the daily weeds.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.4}>
              <div className="mt-12 grid grid-cols-2 gap-6 pt-8 border-t border-brand-cream/10">
                <div>
                  <span className="block text-brand-terra font-serif text-3xl mb-2">16</span>
                  <span className="text-sm tracking-wide text-brand-cream/60">Years Experience</span>
                </div>
                <div>
                  <span className="block text-brand-terra font-serif text-3xl mb-2">5+</span>
                  <span className="text-sm tracking-wide text-brand-cream/60">Complex Sectors</span>
                </div>
              </div>
            </Reveal>
          </div>

        </div>
      </div>
    </section>
  );
}